/**
 * Frontend mirror of the backend support enums.
 * Keep aligned with InviteCloudBackend/src/support/constants.ts.
 */
import type {
  FaqCategoryKey,
  SupportTicketCategory,
  SupportTicketPriority,
  SupportTicketStatus,
} from '@/src/infrastructure/lib/api'

export const SUPPORT_TICKET_CATEGORY_OPTIONS: {
  value: SupportTicketCategory
  label: string
  hint: string
}[] = [
  { value: 'ACCOUNT', label: 'Account', hint: 'Login, profile, plan changes' },
  { value: 'BILLING', label: 'Billing', hint: 'Payments, invoices, refunds' },
  { value: 'TEMPLATE', label: 'Template', hint: 'Issues with a specific template' },
  { value: 'INVITATION', label: 'Invitation', hint: 'Editing or content issues' },
  { value: 'PUBLISHING', label: 'Publishing', hint: 'Cannot publish or page is down' },
  { value: 'RSVP', label: 'RSVP', hint: 'RSVPs not working correctly' },
  { value: 'MEDIA', label: 'Media', hint: 'Photo / video upload problems' },
  { value: 'BUG', label: 'Bug', hint: "Something's broken" },
  { value: 'FEATURE_REQUEST', label: 'Feature request', hint: 'We should add this' },
  { value: 'OTHER', label: 'Other', hint: 'Anything else' },
]

export const SUPPORT_PRIORITY_OPTIONS: {
  value: SupportTicketPriority
  label: string
}[] = [
  { value: 'LOW', label: 'Low' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH', label: 'High' },
  { value: 'URGENT', label: 'Urgent' },
]

export const TICKET_STATUS_LABEL: Record<SupportTicketStatus, string> = {
  OPEN: 'Open',
  IN_PROGRESS: 'In progress',
  WAITING_FOR_USER: 'Awaiting your reply',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed',
}

export const TICKET_STATUS_TONE: Record<SupportTicketStatus, string> = {
  OPEN: 'bg-amber-500/15 text-amber-700 border-amber-500/30',
  IN_PROGRESS: 'bg-sky-500/15 text-sky-700 border-sky-500/30',
  WAITING_FOR_USER: 'bg-violet-500/15 text-violet-700 border-violet-500/30',
  RESOLVED: 'bg-emerald-500/15 text-emerald-700 border-emerald-500/30',
  CLOSED: 'bg-zinc-500/15 text-zinc-700 border-zinc-500/30',
}

export const TICKET_PRIORITY_TONE: Record<SupportTicketPriority, string> = {
  LOW: 'text-zinc-500',
  MEDIUM: 'text-sky-600',
  HIGH: 'text-amber-600',
  URGENT: 'text-rose-600',
}

export const FAQ_CATEGORY_LABEL: Record<FaqCategoryKey, string> = {
  GETTING_STARTED: 'Getting started',
  TEMPLATES: 'Templates',
  INVITATIONS: 'Invitations',
  RSVP: 'RSVP',
  BILLING: 'Billing & plans',
  ACCOUNT: 'Account',
  TROUBLESHOOTING: 'Troubleshooting',
  OTHER: 'Other',
}
